import { render, staticRenderFns } from "./AppUpdateAvailableBanner.vue?vue&type=template&id=254c9a8b"
import script from "./AppUpdateAvailableBanner.vue?vue&type=script&lang=js"
export * from "./AppUpdateAvailableBanner.vue?vue&type=script&lang=js"
import style0 from "./AppUpdateAvailableBanner.vue?vue&type=style&index=0&id=254c9a8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports